"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

const fallbackImage = "/image/membership/star4-placeholder.jpg";

const encodeUrl = (url: string) => {
  const bytes = new TextEncoder().encode(url);
  let binary = "";

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

const getImageSource = (
  source: string | null | undefined,
  origin: string | null | undefined,
  offerUrl: string | null | undefined,
) => {
  if (!source || source.includes("empty.gif")) {
    return null;
  }

  try {
    const url = new URL(source.replace(/\\([./:])/g, "$1"));
    if (/\.(mp4|webm|mov)(?:$|[?#])/i.test(url.pathname)) {
      return null;
    }

    if (/(^|\.)ceskereality\.cz$/i.test(url.hostname)) {
      url.pathname = url.pathname
        .replace("/32x32_webp/", "/320x320_webp/")
        .replace("/32x32_jpg/", "/320x320_jpg/");
    }

    const searchParams = new URLSearchParams({
      origin: origin?.trim() ?? "",
    });
    if (offerUrl) {
      searchParams.set("offerUrl", offerUrl);
    }

    return `/api/watchdog-image/${encodeUrl(url.toString())}?${searchParams}`;
  } catch {
    return null;
  }
};

type EstateOfferImageProps = {
  source: string | null | undefined;
  origin: string | null | undefined;
  offerUrl?: string | null | undefined;
  alt: string;
  sizes: string;
};

export function EstateOfferImage({
  source,
  origin,
  offerUrl,
  alt,
  sizes,
}: EstateOfferImageProps) {
  const imageSource = getImageSource(source, origin, offerUrl);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [imageSource]);

  return (
    <>
      <Image
        src={fallbackImage}
        alt=""
        fill
        unoptimized
        priority
        sizes={sizes}
        className="object-cover"
        aria-hidden="true"
      />

      {imageSource && !hasError && (
        <Image
          src={imageSource}
          alt={alt}
          fill
          unoptimized
          loading="lazy"
          sizes={sizes}
          className="object-cover"
          onError={() => setHasError(true)}
        />
      )}
    </>
  );
}
